var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('span',[_vm._v("详细数据")])])
}]

export { render, staticRenderFns }